import { createElement, useCallback, useState } from "react";
import { phaseChange } from "./addToPhase";
import { UndoToast } from "./UndoToast";

// Putting a task in a part of today, with "Added to Evening · Undo" afterwards. save(taskId, fields)
// writes the task and returns a promise. The message shows straight away and is replaced with an error
// if the write fails. Today's "+ Add task" and Radar's "Add to today" both use it, so both read the same.
// { focusUndo } moves keyboard focus to Undo, for a button that disappears once its task is added.
// addNow(task) is every list's "Add to today": the part of the day it is now (`nowPhase`), focus to Undo.
export function usePhaseAdd(save, nowPhase) {
  const [shown, setShown] = useState(null);
  const clear = useCallback(() => setShown(null), []);
  const failed = (message) => (e) => {
    console.error("Saving the task failed:", e);
    setShown({ message, at: Date.now() });
  };
  const add = (task, phaseId, { focusUndo = false } = {}) => {
    const { update, before, message } = phaseChange(task, phaseId);
    setShown({ taskId: task.id, before, message, focusUndo, at: Date.now() });
    save(task.id, update).catch(failed(`We couldn't add "${task.text}". Check your connection and try again.`));
  };
  const undo = () => {
    save(shown.taskId, shown.before).catch(failed("We couldn't undo that. Check your connection and try again."));
    setShown(null);
  };
  const toast = shown && createElement(UndoToast, {
    key: shown.at, message: shown.message, onDone: clear,
    onUndo: shown.before ? undo : null, takeFocus: shown.focusUndo,
  });
  const addNow = (task) => add(task, nowPhase, { focusUndo: true });
  return { add, addNow, toast };
}
